import script from "./WorldRecords.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorldRecords.vue?vue&type=script&setup=true&lang=ts"

import "./WorldRecords.vue?vue&type=style&index=0&id=7f4cb774&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4cb774"]])

export default __exports__